import React from 'react';

import { Request } from 'components/Request.jsx';
import InputSwitch from '../../elements/InputSwitch';
import InlineError from 'react/elements/InlineError';

export default class CharacterLockInputComponent extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			checked: props.active,
			changing: false,
			error: null,
		};

		this.onChanger = this.onChange.bind(this);
	}

	onChange(e) {
		const checked = e.target.checked;
		const { match } = this.props;
		match.character_lock_enabled = checked;
		this.setState({
			checked: checked,
			changing: true,
			error: null,
		});

		let data = {
			ladder_id: this.props.match.ladder.id,
			enabled: checked ? 1 : 0
		};
		Request.post(siteUrl + '/apiv1/lock_character_picks', data)
			.then(() => {
				this.setState({
					changing: false,
				});
			})
			.catch((response) => {
				console.error(response);
				match.character_lock_enabled = !checked;
				this.setState({
					checked: !checked,
					changing: false,
					error: response?.responseJSON?.error || 'There was an error saving your change',
				});
			});
	}

	render() {
		const { match, character } = this.props;
		const { changing, checked, error } = this.state;
		if(match.isAutoReportedOnly()) {
			return null;
		}

		return (
			<div className='lock_character_secondary flex'>
				<InputSwitch
					disabled={changing}
					content={<span>Lock {character
						? <span className='primary_highlight'>{character.name}</span>
						: 'Character'} for the rest of the set?</span>
					}
					onChange={this.onChanger}
					name='lock_character'
					checked={checked}
				/>
				<InlineError message={error} />
			</div>
		);

	}
}